import { BitcoinCircle, EthCircle, MUsdCircle, TBtcCircle, } from "@mezo-org/mezo-clay";
import { createElement } from "react";
const CRYPTO_ASSETS = {
    btc: {
        name: "Bitcoin",
        symbol: "BTC",
        icon: BitcoinCircle,
        decimals: 8,
    },
    eth: {
        name: "Ethereum",
        symbol: "ETH",
        icon: EthCircle,
        decimals: 18,
    },
    tbtc: {
        name: "Threshold Bitcoin",
        symbol: "tBTC",
        icon: TBtcCircle,
        decimals: 18,
    },
    wbtc: {
        name: "Wrapped Bitcoin",
        symbol: "wBTC",
        icon: (props) => createElement(BitcoinCircle, {
            ...props,
            symbolColor: "#FF8A00",
            color: "#000000",
        }),
        decimals: 8,
    },
    mbtc: {
        name: "Matsnet Bitcoin",
        symbol: "BTC",
        icon: (props) => createElement(BitcoinCircle, {
            ...props,
            symbolColor: "#000000",
            color: "#FFC907",
        }),
        decimals: 18,
    },
    musd: {
        name: "Mezo USD",
        symbol: "MUSD",
        icon: MUsdCircle,
        decimals: 18,
    },
};
/**
 * Gets details of given crypto asset
 * @param key The key of crypto asset
 * @returns The crypto asset details
 */
export function getCryptoAsset(key) {
    return CRYPTO_ASSETS[key];
}
/**
 * Checks if given crypto asset is Bitcoin-like
 * @param key The key of crypto asset
 * @returns True if crypto asset is Bitcoin-like
 */
export function isBitcoinLikeCryptoAsset(key) {
    return ["btc", "tbtc", "wbtc", "mbtc"].includes(key);
}
/**
 * Checks if given crypto asset is USD-like
 * @param key The key of crypto asset
 * @returns True if crypto asset is USD-like
 */
export function isUsdLikeCryptoAsset(key) {
    return ["musd"].includes(key);
}
//# sourceMappingURL=cryptoAssets.js.map